import React from 'react'
import decodeHtml from '../functions/decodeHtml'
import getTranslation from '../functions/getTranslation'
import Translation from '../General/Translation'


const Directors = ({directors, actors, translation}) => {
    if (!directors) {
        return ''
    }
    
    const text = (!actors || !actors[0]) ? ' ' + getTranslation('movieBy', translation) + ' ' : ' ' + getTranslation('inMovieBy', translation) + ' '

    if(directors.length === 1) {
        return <span className="text-light">{text + decodeHtml(directors[0].name)} </span>
    } else if(directors.length === 2) {
        return <span className="text-light"><Translation id="and" trans={translation} before={text + decodeHtml(directors[0].name) + ' '} after={' ' + decodeHtml(directors[1].name)}>und</Translation></span>
    } else {
        return ''
    }
    
}

export default Directors